import React from 'react'
import { Helmet } from "react-helmet";
import PastParticipantedMarketing from '../Components/PastParticipatedMareketing.jsx';
import MarketingGallery from '../Components/MarketingGallery.jsx';
import {BannerDataMark} from "../Components/data.js";
import BannerSection from "../Components/BannerSection.jsx";
import {MarketingGData} from "../Components/data.js";
import Eleveting  from '../Components/Eleveting.jsx';
import {MarketingConfAbout} from "../Components/data.js";
import AboutAllConf  from '../Components/AboutAllConf.jsx';

export const Fueld = () => {
  return (
    <>
<Helmet>
<meta charset="utf-8" />
<title> Top AI Conference Is Coming To Dubai (2025) & Las Vegas (2026)</title>
<base href="/" />
<meta name="description" content=" Be a part of our AI summit and connect with thought leaders, featuring impactful discussions, practical applications, and collaborative opportunities in AI. " />
<meta property="og:title" content="Top AI Conference Is Coming To Dubai (2025) & Las Vegas (2026)" />
<meta property="og:description" content="Be a part of our AI summit and connect with thought leaders, featuring impactful discussions, practical applications, and collaborative opportunities in AI." />

</Helmet>

      {/* ====================== */}
      <BannerSection bannerContent={BannerDataMark}/>
      {/* ======================= */}
      <Eleveting SpeakAbout={MarketingGData}/>
      {/* =================== */}
      <AboutAllConf ConfAbout={MarketingConfAbout}/>
       {/* =================== */}
       
      <PastParticipantedMarketing/>
      <MarketingGallery/>
{/* =================== */}
    </>
  )
}



export default Fueld;